import { render } from "./Security.vue?vue&type=template&id=20a2df58"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__